let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Nd4C")).then(() => parcelRequire('fdZLV'));